import { AfterViewInit, OnInit, ViewChild } from "@angular/core";
import { Component } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { finalize } from "rxjs/operators";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { RequestedService } from "src/app/models/RequestedService";
import { GlobalOverlayService } from "src/app/services/global-overlay.service";
import { ModalService } from "src/app/services/modal.service";
import { RequestedServiceService } from "src/app/services/requested-services.service";

@Component({
  selector: "app-requested-service-list",
  templateUrl: "./requested-service-list.component.html",
  styleUrls: ["./requested-service-list.component.scss"],
  standalone: false,
})
export class RequestedServiceListComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  readonly routeNameConstants = RouteNameConstants;
  readonly localizationConstants = LocalizationConstants;

  faSpinner = faSpinner;
  selectedFamCode: string;
  famCodes: string[];
  currentValue: string;
  currentDisplayValue: string;
  pageSize = 10;
  dataSource = new MatTableDataSource<RequestedService>([]);

  constructor(
    private requestedServicesService: RequestedServiceService,
    public modalService: ModalService,
    private globalOverlayService: GlobalOverlayService,
  ) {}

  ngOnInit(): void {
    this.loadFamCodes();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  loadFamCodes() {
    this.globalOverlayService.show();
    this.requestedServicesService
      .getFamCodes()
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe((response) => (this.famCodes = response));
  }

  onValueChange() {
    this.currentDisplayValue = this.currentValue;
  }

  loadRequestedServiceList() {
    this.globalOverlayService.show();
    this.requestedServicesService
      .getRequestedServices(this.selectedFamCode)
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe((response) => {
        this.dataSource.data = response;
        this.currentValue = null;
        this.currentDisplayValue = null;
      });
  }

  onServiceRequestAdd() {
    if (!this.currentValue || !this.currentDisplayValue) {
      return;
    }

    const serviceRequest = new RequestedService();
    serviceRequest.company = this.selectedFamCode;
    serviceRequest.value = this.currentValue;
    serviceRequest.displayValue = this.currentDisplayValue;

    this.globalOverlayService.show();
    this.requestedServicesService
      .addServiceRequest(serviceRequest)
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe(() => this.loadRequestedServiceList());
  }

  onServiceRequestDelete(serviceRequest: RequestedService) {
    serviceRequest.company = this.selectedFamCode;
    this.globalOverlayService.show();
    this.requestedServicesService
      .deleteServiceRequest(serviceRequest)
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe(() => this.loadRequestedServiceList());
  }
}
